<ng-container *transloco="let t">
  <div class="step">
    <div class="step-content">
      <div class="subscription-cost">
        <section class="payment-alert">
          <section class="payment-alert__top">
            <div class="payment-alert__header">
              <i class="ci-info_circle_outline"></i>
              <div class="payment-alert__text">
                <p class="bold">{{ t('subscription.alertTitle') }}</p>
                <p class="normal">
                  {{ t('subscription.alertSubtitle') }}
                </p>
              </div>
            </div>
            <a (click)="showSubscriptionDetails = !showSubscriptionDetails">{{
              t('subscription.alertDetails')
            }}</a>
          </section>
          <section class="payment-alert__bottom">
            @if (showSubscriptionDetails) {
              <ul class="payment-notes list">
                <li>
                  {{ t('subscription.alertDescriptionOne') }}
                </li>
                <li>
                  {{ t('subscription.alertDescriptionTwo') }}
                </li>
                <li>
                  {{ t('subscription.alertDescriptionThree') }}
                </li>
              </ul>
            }
          </section>
        </section>
      </div>
      <dx-validation-group #validationGroup>
        @if (countryCode !== 'AR') {
          <pxw-stripe-payment #stripePayment [billingName]="customerFullName"> </pxw-stripe-payment>
          <pxw-stripe-coupon-code
            [apiUrl]="apiUrl"
            [billingType]="billingType"
            [promotionCode]="promotionCode"
            (handleCouponSuccess)="handleCouponSuccess($event)"
            (handleCouponError)="handleCouponError($event)"
          ></pxw-stripe-coupon-code>
        }

        @if (countryCode === 'AR') {
          <div class="payment-method-toggle" role="radiogroup" aria-label="Método de pago">
            <button
              type="button"
              role="radio"
              class="toggle-option"
              [class.active]="paymentMethodType === 'card'"
              [attr.aria-checked]="paymentMethodType === 'card'"
              (click)="paymentMethodType = 'card'"
            >
              {{ t('subscription.paymentMethodCard') }}
            </button>
            <button
              type="button"
              role="radio"
              class="toggle-option"
              [class.active]="paymentMethodType === 'cbu'"
              [attr.aria-checked]="paymentMethodType === 'cbu'"
              (click)="onSelectCbu()"
            >
              {{ t('subscription.paymentMethodCbu') }}
            </button>
          </div>

          @if (paymentMethodType === 'card') {
            <pxw-argentine-payment
              [cardModel]="cardModel"
            ></pxw-argentine-payment>
          }

          @if (paymentMethodType === 'cbu') {
            <pxw-argentine-cbu-payment
              [cbuModel]="cbuModel"
              [banks]="banks()"
            ></pxw-argentine-cbu-payment>
          }
        }

        <div class="checkbox-content">
          <dx-check-box
            validationMessageMode="always"
            [(value)]="registrationSharedService.registrationData.acceptTermsAndConditions"
            >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                [message]="t('subscription.termsAndConditionsRequired')"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-check-box>
          <p [innerHTML]="t('subscription.termsAndConditions')"></p>
        </div>
      </dx-validation-group>
    </div>
    <div class="button-wrapper">
      <pxw-button display="block" type="warning" size="md" [disabled]="loading" (click)="prev()">
        <i class="ci-short_left"></i>
        {{ t('general.back') }}
      </pxw-button>
      <pxw-button
        mode="submit"
        display="block"
        type="warning"
        size="md"
        [loading]="loading"
        (click)="processPayment()"
        >
        {{ t('general.suscribe') }}
      </pxw-button>
    </div>
  </div>
</ng-container>
